import { render, staticRenderFns } from "./addListBox.vue?vue&type=template&id=0504dca0"
import script from "./addListBox.vue?vue&type=script&lang=js"
export * from "./addListBox.vue?vue&type=script&lang=js"
import style0 from "./addListBox.vue?vue&type=style&index=0&id=0504dca0&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports